import { DataKey } from 'enums/DataKey';
import { AllResultTypes, constants, IDataGridColumnConfiguration, IDataGridValidator } from '@trackman/baseball-shared-components';
import { PlayRow } from 'models/PlayEditRow/PlayRow';
import { IError } from 'interfaces/sessionVerification/plays/IPlayPreviewRow';

export const playResultValidator: IDataGridValidator = {
  validate: (rows: PlayRow[], columns: IDataGridColumnConfiguration[]) => {
    const columnObj = {} as { key: Record<DataKey, IDataGridColumnConfiguration> };

    for (const column of columns) {
      // @ts-ignore
      columnObj[column.dataKey] = column;
    }

    // @ts-ignore
    const { playResult } = columnObj;

    if (!playResult) {
      return rows.map(() => []);
    }

    return rows.map((r) => validateRow(r, r.firstBase, r.secondBase, r.thirdBase, playResult));
  },
};

const validateRow = (
  row: PlayRow,
  firstBase: any,
  secondBase: any,
  thirdBase: any,
  playResultColumn: IDataGridColumnConfiguration
): IError[] => {
  const errors: IError[] = [];
  if (row.isWarmup || row.isDeleted) {
    return [];
  }

  const playResult = row[playResultColumn.dataKey];

  const noPlayersOnBases = (firstBase: any, secondBase: any, thirdBase: any): boolean => {
    return (
      (!firstBase || firstBase.id === constants.emptyGuid) &&
      (!secondBase || secondBase.id === constants.emptyGuid) &&
      (!thirdBase || thirdBase.id === constants.emptyGuid)
    );
  };

  if (playResult === AllResultTypes.StolenBase || playResult === AllResultTypes.CaughtStealing) {
    if (noPlayersOnBases(firstBase, secondBase, thirdBase)) {
      errors.push({
        dataKey: `${playResultColumn.dataKey}-firstBase-secondBase-thirdBase`,
        errorMessage: `Play result can't be ${playResult} - no players on bases`,
      });
    }
  }

  return errors;
};
